import config from "src/config";
import TagManager from "react-gtm-module";

TagManager.initialize({ gtmId: config.gtmAcc! });